import { createFileRoute } from '@tanstack/react-router'

import { ValuationRulesScreen } from '@/features/valuation-rules/valuation-rules-screen'

export const Route = createFileRoute('/_app/_org/settings/valuation-rules')({
  component: ValuationRulesScreen,
})
